import React, { FC } from 'react';

import styled from '@emotion/styled';
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  compose
} from '@lucid/theme';

import { CardActionProps } from './card-action';

export interface CardActionsProps
  extends SpaceProps,
  LayoutProps {}

const cardActionsStyleProps = compose(
  space,
  layout
);

const StyledCardActions = styled.div<CardActionsProps>(
  ({ theme }) => ({
    label: 'cardActions',
    display: 'flex',
    marginTop: `${theme.space ? theme.space[3] : 0}px`
  }),
  cardActionsStyleProps
);

const CardActions: FC<CardActionProps> = (props) => (
  <StyledCardActions {...props} />
);

export { CardActions };
export default CardActions;
